import handlebars from "handlebars";
import { AppraisalAssetsModel, GetAppraisalModel } from "../../../../../all_Interfaces";
import currencySymbolMap from "currency-symbol-map";
import cmAppraisalValuesTemplate from "../templates/cmAppraisalValuesTemplate";
import equityAssetTemplate from "../templates/equityAssetTemplate";

export const compileEquityAssetTemplate = (
    appraisalData:GetAppraisalModel
  ): string => {
    const compiledEquityAssetTemplate = handlebars.compile(equityAssetTemplate);
    const dayjs = require('dayjs');

    const formatNumber = (params:any) => {
        if(params !== null)
          return '$ ' + params.toLocaleString('en-US');
         
        return '';
      }

    var currencySymbol = "$";
    if(appraisalData.currency != "ZH"){
        currencySymbol = currencySymbolMap(appraisalData.currency) as string
    }else{
        currencySymbol = "ZH";
    }

    const formatNumberTo0Decimal = (num: any) => {
        const regxmain = /^-?\d+(\.\d+)?$/;  
        const regex1 = /^\d+\.\d{1}$/;
        const regx2 = /^\d+$/;
        const regx3 = /^-?\d+\.\d{1}$/; // tocheck - number
        if (regxmain.test(num)) {
          return num.toFixed(2);
        }
        // if (regex1.test(num)) {
        //   return num.toFixed(2);
        // }else  if(regx2.test(num)) {
        //   return num.toFixed(2);
        // }else if(regx3.test(num)){
        //   return `${num.toFixed(2)}`;
        // }
        return num;
      }

    var ast = [...appraisalData.assets];
    appraisalData.assets.forEach((data:AppraisalAssetsModel,index:number)=>{
        ast[index] = {...data,
            dcfValue:formatNumber(data.dcfValue),
            currentAppraisalValue:formatNumber(data.currentAppraisalValue),
            lastAppraisedValue:formatNumber(data.lastAppraisedValue),
            lastAnnualAppraisedValue:formatNumber(data.lastAnnualAppraisedValue),
            discountRate: formatNumberTo0Decimal(data.discountRate),
            impliedCapRateYr1: formatNumberTo0Decimal(data.impliedCapRateYr1),
            terminalCapRate: formatNumberTo0Decimal(data.terminalCapRate)
        }
    })

    const assetsData = {
        assets: [...ast],
        currency:appraisalData.currency,
        currencySymbol : currencySymbol,
        empty: appraisalData.assets.length == 0 ? 'true' : 'false'
    }

    console.log(assetsData);

    return compiledEquityAssetTemplate(assetsData);
}